// OONA CUSTOM — barre de progression des cartes produit (collections).
// Les flèches sont supprimées : on swipe, et la barre fine en bas de l'image
// indique la position. Synchronisation par MutationObserver sur la classe
// is-active des slides (même approche que le compteur du hero produit).
class ProductCardMediaGallery extends HTMLElement {
  connectedCallback() {
    this.bar = this.querySelector('[data-card-progress]');
    const list = this.querySelector('.splide__list');
    if (!this.bar || !list) return;

    const update = () => {
      const slides = [...this.querySelectorAll('.splide__slide:not(.splide__slide--clone)')];
      if (slides.length < 2) {
        this.bar.parentElement.style.display = 'none';
        return;
      }
      const active = this.querySelector('.splide__slide.is-active:not(.splide__slide--clone)');
      const index = Math.max(0, slides.indexOf(active));
      this.bar.style.width = (((index + 1) / slides.length) * 100).toFixed(1) + '%';
    };

    this.observer = new MutationObserver(update);
    this.observer.observe(list, { subtree: true, attributes: true, attributeFilter: ['class'] });
    update();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('product-card-media-gallery')) {
  customElements.define('product-card-media-gallery', ProductCardMediaGallery);
}
